import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicControlsSharedState, IStaticInputList
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { ElementTypes } from '../shared/models/models';

export class StaticListInputVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    private sharedState: IDynamicControlsSharedState;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        this.sharedState = sharedState;
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return propValue.elementType === ElementTypes.ElementList;
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {

        let staticList: IStaticInputList =  propValue as IStaticInputList;

        // assign index of value to order property on starting object so that getPropsToVisit returns the correct order for the children
        staticList.items.forEach(item => {
            item.order = item.value.index;
        });

        this.currentGrouping.$controlInputs.push(staticList);

        staticList.$isContainer = true;
        staticList.$fieldName = this.sharedState.nextId();
        staticList.$categories = [];
        staticList.$sections = [];
        staticList.$inputType = 'inputSection';
        staticList.$controlInputs = [];

        return null;
    }
}
